// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"highlight-info__wrapper___1X7id","headerCenter":"highlight-info__headerCenter___1G4sZ","list":"highlight-info__list___3DOVU"};


//////////////////
// WEBPACK FOOTER
// ./src/components/highlight-info/highlight-info.scss
// module id = 604
// module chunks = 0